<template>
  <div class="main-wrapper">
    <Sidebar />
    <div class="page-wrapper">
      <Navbar />
      <div class="page-content">
        <router-view />
      </div>
    </div>
  </div>
</template>

<script>
import Sidebar from '../components/sidebar/Sidebar.vue'
import Navbar from '../components/navbar/Navbar.vue'
export default {
  name: 'app-layout',
  components: {
    Navbar,
    Sidebar
  }
}
</script>